import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const AboutUs = () => (
  <LegalPageLayout>
    <div className="legal-page">
      <div className="container legal-content text-center">
        <h2>About Us</h2>
        <p>This is a placeholder About Us page. Add your company story and mission here.</p>
      </div>
    </div>
  </LegalPageLayout>
);

export default AboutUs; 